import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  TabContent,
  TabPane,
  NavItem,
  NavLink,
  Label,
  Progress,
  Container,
  Spinner,
} from "reactstrap";
import { validateToken, has_Permission } from "../../helpers/jwt-token-access/accessToken";
import { AvForm, AvField } from "availity-reactstrap-validation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import classnames from "classnames";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { Link } from "react-router-dom";
import { BaseUrl } from "../../helpers/Baseurl";
import { getDifferenceInDays } from "../../helpers/methods";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const PackegeTypeGroup = [
  {
    label: "Package Type",
    options: [
      { label: "Budget", value: "Budget" },
      { label: "Standard", value: "Standard" },
      { label: "Deluxe", value: "Deluxe" },
      { label: "Premium", value: "Premium" },
      { label: "Platinum", value: "Platinum" },
    ],
  },
];

class NewItinerary extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"));
    if (!this.obj) {
      this.props.history.push("/logout");
    } else if (!validateToken(this.obj.access)) {
      this.props.history.push("/logout");
    }
    if (!has_Permission(this.obj.user, 1, "create")) {
      this.props.history.push("/itineraries");
    }
    this.state = {
      breadcrumbItems: [
        { title: "Itineraries", link: "/itineraries" },
        { title: "Add New Itinerary", link: "#" },
      ],
      activeTab: 1,
      activeTabProgress: 1,
      progressValue: 25,
      loading: false,
      selectedStartDate: null,
      selectedendDate: null,
      LocationsGroup: [],
      DestinationGroup: [],
      selectedDestinations: [],
      selectedVisitingLocation: [],
      DestinationsLocationGroup: [
        { label: "Locations", options: [{ label: "Select All", value: "all" }] },
      ],
      selectedPickLocation: { label: "Select Pickup Location", value: null },
      selectedDropLocation: { label: "Select Drop Off Location", value: null },
      selectedPackegeType: [],
      count: 1,
    };

    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "false",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onLocationInputChange = this.onLocationInputChange.bind(this);
    this.toggleTab = this.toggleTab.bind(this);
    this.toggleTabProgress = this.toggleTabProgress.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadDestinationsLocationData = this.loadDestinationsLocationData.bind(this);
    this.handleSelectedVisitingLocation = this.handleSelectedVisitingLocation.bind(this);
    this.addInput = this.addInput.bind(this);
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 4) {
        this.setState({ activeTab: tab });
      }
    }
  }

  toggleTabProgress(tab) {
    if (this.state.activeTabProgress !== tab) {
      if (tab >= 1 && tab <= 4) {
        this.setState({ activeTabProgress: tab });
        if (tab === 1) this.setState({ progressValue: 33 });
        if (tab === 2) this.setState({ progressValue: 67 });
        if (tab === 3) this.setState({ progressValue: 101 });
      }
    }
  }

  addInput() {
    const { count } = this.state;
    this.setState({ count: count + 1 });
  }

  removeInput() {
    const { count, selectedDestinations } = this.state;
    let newdata = selectedDestinations;
    newdata.pop();
    this.setState({ count: count - 1, selectedDestinations: newdata });
  }

  async componentDidMount() {
    await this.loadDestinationData("?parent=null");
    await this.loadLocationData(`${BaseUrl}/api/locations/location/locations/`);
  }

  async loadDestinationData(filer_queryset) {
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${this.obj.access}` },
    };
    await fetch(`${BaseUrl}/api/locations/location/locations/${filer_queryset}`, requestOptions)
      .then((res) => res.json())
      .then(
        (data) => {
          let options = data.results.map((destination) => ({
            label: destination.name,
            value: destination.id,
          }));
          let DestinationGroup = [{ label: "Destination", options }];
          this.setState({ DestinationGroup });
        },
        (error) => {
          console.log(error, "error--------------");
        }
      );
  }

  async loadLocationData(url) {
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${this.obj.access}` },
    };
    await fetch(url, requestOptions)
      .then((res) => res.json())
      .then(
        (data) => {
          let options = data.results.map((location) => ({
            label: location.name,
            value: location.id,
          }));
          let LocationsGroup = [{ label: "Locations", options }];
          this.setState({ LocationsGroup });
        },
        (error) => {
          console.log(error, "error--------------");
        }
      );
  }

  async loadDestinationsLocationData(ids) {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.obj.access}`,
      },
    };
    await fetch(`${BaseUrl}/api/locations/locations/?ids=${ids}`, requestOptions)
      .then((res) => res.json())
      .then(
        (data) => {
          let options = data.map((location) => ({
            label: location.name,
            value: location.id,
          }));
          const allOption = { label: "Select All", value: "all" };
          let DestinationsLocationGroup = [
            {
              label: "Locations",
              options: [allOption, ...options],
            },
          ];
          this.setState({ DestinationsLocationGroup });
        },
        (error) => {
          console.log(error, "error--------------");
        }
      );
  }

  async loadDestinationLocations(id) {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.obj.access}`,
      },
    };
    await fetch(`${BaseUrl}/api/locations/location/locations/?parent=${id}&size=50`, requestOptions)
      .then((res) => res.json())
      .then(
        (data) => {
          let options = data.map((location) => ({
            label: location.name,
            value: location.id,
          }));
          const allOption = { label: "Select All", value: "all" };
          let DestinationsLocationGroup = [
            {
              label: "Locations",
              options: [allOption, ...options],
            },
          ];
          this.setState({ DestinationsLocationGroup });
        },
        (error) => {
          console.log(error, "error--------------");
        }
      );
  }

  onInputChange(e) {
    this.loadDestinationData(`?parent=null&search=${e}`);
  }

  onLocationInputChange(e) {
    this.loadLocationData(`${BaseUrl}/api/locations/location/locations/?search=${e}`);
  }

  handleSelectedPackegeType = (selectedPackegeType) => {
    this.setState({ selectedPackegeType });
  };

  handleselectedPickupLocation = (selectedPickLocation) => {
    this.setState({ selectedPickLocation });
  };

  handleselectedDropOffLocation = (selectedDropLocation) => {
    this.setState({ selectedDropLocation });
  };

  handleselectedDestinations = (selectedDestinations) => {
    let destinations = [];
    for (let i = 0; i < selectedDestinations.length; i++) {
      destinations.push(selectedDestinations[i].value);
    }
    this.loadDestinationsLocationData(destinations.toString());
    let selectedVisitingLocation = [];
    this.setState({ selectedDestinations, selectedVisitingLocation });
  };

  handleSelectedVisitingLocation(selectedVisitingLocation) {
    const { DestinationsLocationGroup } = this.state;

    if (!selectedVisitingLocation || selectedVisitingLocation.length === 0) {
      this.setState({ selectedVisitingLocation: [] });
      return;
    }

    const isAllSelected = selectedVisitingLocation.some((option) => option.value === "all");

    if (isAllSelected) {
      const allOptions = DestinationsLocationGroup[0].options.filter(
        (option) => option.value !== "all"
      );
      this.setState({ selectedVisitingLocation: allOptions });
    } else {
      this.setState({ selectedVisitingLocation });
    }
  }

  handleselectedDestination = (selectedDestination) => {
    this.loadDestinationLocations(selectedDestination.value);
    this.setState({ selectedDestination });
  };

  handleselectedStartDate = (selectedStartDate) => {
    this.setState({ selectedStartDate });
  };

  handleSubmit(e, values) {
    const {
      selectedDestinations,
      selectedDropLocation,
      selectedPickLocation,
      selectedStartDate,
      selectedendDate,
      selectedPackegeType,
      selectedVisitingLocation,
    } = this.state;

    if (selectedVisitingLocation.length === 0) {
      toastr.error("Select Visiting Places", "");
    } else if (selectedStartDate === null || selectedendDate === null) {
      toastr.error("Please Select Tour Start Date and End Date", "");
    } else if (selectedDropLocation.value === null || selectedPickLocation.value === null) {
      toastr.error("Please Select Pick up and Drop Off Location", "");
    } else if (selectedPackegeType.length === 0) {
      toastr.error("Please Select Package Type", "");
    } else {
      this.setState({ loading: true });

      let selected_destini = [];
      for (let i = 0; i < selectedDestinations.length; i++) {
        selected_destini.push(selectedDestinations[i].value);
      }
      let selected_places = [];
      for (let i = 0; i < selectedVisitingLocation.length; i++) {
        selected_places.push(selectedVisitingLocation[i].value);
      }
      let selectedPackege = [];
      for (let i = 0; i < selectedPackegeType.length; i++) {
        selectedPackege.push(selectedPackegeType[i].value);
      }
      let dateDiff = getDifferenceInDays(selectedStartDate, selectedendDate);
      let title =
        values.name +
        " " +
        ` Tour ${dateDiff}N/${dateDiff + 1}Day Ex ${selectedPickLocation.label} (${
          values.customer_name
        })`;

      let data = {};
      data["name"] = values.name;
      data["title"] = title;
      data["customer_name"] = values.customer_name;
      data["phone"] = values.phone;
      data["email"] = values.email;
      data["address"] = values.address;
      data["zip_code"] = values.zip_code;
      data["packeges"] = selectedPackege;
      data["packege"] = selectedPackegeType[0].value;
      data["start_date"] = `${selectedStartDate.getFullYear()}-${selectedStartDate.getMonth() + 1}-${selectedStartDate.getDate()}`;
      data["end_date"] = `${selectedendDate.getFullYear()}-${selectedendDate.getMonth() + 1}-${selectedendDate.getDate()}`;
      data["adults_male"] = values.adults_male;
      data["adults_female"] = values.adults_female;
      data["teens_male"] = values.teens_male === "" ? 0 : values.teens_male;
      data["teens_female"] = values.teens_female === "" ? 0 : values.teens_female;
      data["kids_male"] = values.kids_male === "" ? 0 : values.kids_male;
      data["kids_female"] = values.kids_female === "" ? 0 : values.kids_female;
      data["pax"] =
        parseInt(values.adults_male) +
        parseInt(values.adults_female) +
        parseInt(values.teens_male === "" ? 0 : values.teens_male) +
        parseInt(values.teens_female === "" ? 0 : values.teens_female);
      data["pick_up_location"] = selectedPickLocation.value;
      data["drop_off_location"] = selectedDropLocation.value;
      data["destinations"] = selected_destini;
      data["places"] = selected_places;
      data["created_by"] = this.obj.user.id;
      data["background_color"] = "#" + Math.floor(Math.random() * 16777215).toString(16);

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.obj.access}`,
        },
        body: JSON.stringify(data),
      };

      fetch(`${BaseUrl}/api/itineraries/itineraries/`, requestOptions).then((res) => {
        if (res.status >= 400) {
          res.json().then((data) => {
            console.log(data, "---data");
            toastr.error("Something Went Wrong", "");
            this.setState({ loading: false });
          });
        } else {
          res.json().then((data) => {
            toastr.success(`Itinerary Added Successfully`, "");
            this.props.history.push(`/itinerary-detail/${data.id}`);
          });
        }
      });
    }
  }

  render() {
    const {
      selectedVisitingLocation,
      DestinationsLocationGroup,
      selectedPickLocation,
      selectedDropLocation,
    } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs title="Add New Itinerary" breadcrumbItems={this.state.breadcrumbItems} />
            <Row>
              <Col lg="6">
                <Card>
                  <CardBody>
                    <h4 className="card-title mb-4">Add Itinerary Details</h4>
                    <div id="progrss-wizard" className="twitter-bs-wizard">
                      <ul className="twitter-bs-wizard-nav nav-justified nav nav-pills">
                        <NavItem>
                          <NavLink
                            className={classnames({ active: this.state.activeTabProgress === 1 })}
                            onClick={() => {
                              this.toggleTabProgress(1);
                            }}
                          >
                            <span className="step-number">01</span>
                            <span className="step-title">Customer Details</span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames({ active: this.state.activeTabProgress === 2 })}
                            onClick={() => {
                              this.toggleTabProgress(2);
                            }}
                          >
                            <span className="step-number">02</span>
                            <span className="step-title">Tour Details</span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames({ active: this.state.activeTabProgress === 3 })}
                            onClick={() => {
                              this.toggleTabProgress(3);
                            }}
                          >
                            <span className="step-number">03</span>
                            <span className="step-title">Traveller Details</span>
                          </NavLink>
                        </NavItem>
                      </ul>
                      <div id="bar" className="mt-4">
                        <Progress color="success" striped animated value={this.state.progressValue} />
                      </div>
                      <AvForm className="needs-validation" id="itinerary" onValidSubmit={this.handleSubmit}>
                        <TabContent activeTab={this.state.activeTabProgress} className="twitter-bs-wizard-tab-content">
                          <TabPane tabId={1}>
                            <Row>
                              <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="name">
                                    Name
                                  </Label>
                                  <AvField
                                    name="name"
                                    placeholder="Itinerary Name"
                                    type="text"
                                    errorMessage="Enter Itinerary Name"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="name"
                                  />
                                </div>
                              </Col>
                              <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="customer_name">
                                    Customer Name
                                  </Label>
                                  <AvField
                                    name="customer_name"
                                    placeholder="Customer Name"
                                    type="text"
                                    errorMessage="Enter Customer Name"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="customer_name"
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <div className="mb-3">
                                  <AvField
                                    name="phone"
                                    label="Contact Number"
                                    placeholder="Contact Number(+91-9999999999)"
                                    type="text"
                                    errorMessage="Enter Only Digits"
                                    validate={{
                                      required: { value: true },
                                      pattern: {
                                        value: "^[0-9+-]+$",
                                        errorMessage: "Invalid Contact ",
                                      },
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="email">
                                    Email
                                  </Label>
                                  <AvField
                                    name="email"
                                    placeholder="Customer Email"
                                    type="email"
                                    errorMessage="Enter Customer Email"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    id="email"
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="12">
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="address">
                                    Address
                                  </Label>
                                  <AvField
                                    name="address"
                                    placeholder="Customer Address"
                                    type="text"
                                    errorMessage="Enter Address"
                                    className="form-control"
                                    id="address"
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <div className="mb-3 form-floating">
                                  <AvField
                                    name="zip_code"
                                    label="Pin Code"
                                    placeholder="Pin Code"
                                    type="number"
                                    validate={{
                                      pattern: {
                                        value: "^[0-9]+$",
                                        errorMessage: "Only Digits",
                                      },
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </TabPane>
                          <TabPane tabId={2}>
                            <Row>
                              <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label">Package Type</Label>
                                  <Select
                                    value={this.state.selectedPackegeType}
                                    onChange={this.handleSelectedPackegeType}
                                    isMulti={true}
                                    options={PackegeTypeGroup}
                                    classNamePrefix="select2-selection"
                                  />
                                </div>
                              </Col>
                              <Col md="3">
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="start_date">
                                    Start Date
                                  </Label>
                                  <DatePicker
                                    className="form-control"
                                    minDate={new Date()}
                                    selected={this.state.selectedStartDate}
                                    onChange={(date) => this.handleselectedStartDate(date)}
                                    selectsStart
                                    startDate={new Date()}
                                    placeholderText="Select Start Date"
                                    isClearable={true}
                                  />
                                </div>
                              </Col>
                              <Col md="3">
                                <div className="mb-3">
                                  <Label className="form-label" htmlFor="end_date">
                                    End Date
                                  </Label>
                                  <DatePicker
                                    className="form-control"
                                    selected={this.state.selectedendDate}
                                    onChange={(date) => this.setState({ selectedendDate: date })}
                                    selectsEnd
                                    startDate={this.state.selectedStartDate}
                                    minDate={this.state.selectedStartDate}
                                    placeholderText="Select End Date"
                                    isClearable={true}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label">Pickup Location</Label>
                                  <Select
                                    onInputChange={this.onInputChange}
                                    value={this.state.selectedPickLocation}
                                    onChange={this.handleselectedPickupLocation}
                                    options={this.state.DestinationGroup}
                                    classNamePrefix="select2-selection"
                                  />
                                </div>
                              </Col>
                              <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label">Drop off Location</Label>
                                  <Select
                                    onInputChange={this.onInputChange}
                                    value={this.state.selectedDropLocation}
                                    onChange={this.handleselectedDropOffLocation}
                                    options={this.state.DestinationGroup}
                                    classNamePrefix="select2-selection"
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label">Destinations</Label>
                                  <Select
                                    onInputChange={this.onInputChange}
                                    value={this.state.selectedDestinations}
                                    onChange={this.handleselectedDestinations}
                                    isMulti={true}
                                    options={this.state.DestinationGroup}
                                    classNamePrefix="select2-selection"
                                  />
                                </div>
                              </Col>
                              <Col md="6">
                                <div className="mb-3">
                                  <Label className="form-label">Visiting Places</Label>
                                  <Select
                                    value={selectedVisitingLocation}
                                    onChange={this.handleSelectedVisitingLocation}
                                    isMulti={true}
                                    options={DestinationsLocationGroup}
                                    classNamePrefix="select2-selection"
                                    placeholder="Select visiting locations"
                                  />
                                </div>
                              </Col>
                            </Row>
                          </TabPane>
                          <TabPane tabId={3}>
                            <Row>
                              <Col md={6}>
                                <div className="mb-3">
                                  <AvField
                                    name="adults_male"
                                    label="Number of Adults (Male)"
                                    placeholder="Age 18+"
                                    type="number"
                                    errorMessage="Enter Number of Adults (Male)"
                                    validate={{
                                      required: { value: true },
                                      pattern: {
                                        value: "^[0-9]+$",
                                        errorMessage: "Only Digits",
                                      },
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="mb-3">
                                  <AvField
                                    name="adults_female"
                                    label="Number of Adults (Female)"
                                    placeholder="Age 18+"
                                    type="number"
                                    errorMessage="Enter Number of Adults (Female)"
                                    validate={{
                                      required: { value: true },
                                      pattern: {
                                        value: "^[0-9]+$",
                                        errorMessage: "Only Digits",
                                      },
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <div className="mb-3">
                                  <AvField
                                    name="teens_male"
                                    label="Number of Teens (Male)"
                                    placeholder="Age Between 10 to 14"
                                    type="number"
                                    validate={{
                                      pattern: {
                                        value: "^[0-9]+$",
                                        errorMessage: "Only Digits",
                                      },
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="mb-3">
                                  <AvField
                                    name="teens_female"
                                    label="Number of Teens (Female)"
                                    placeholder="Age Between 10 to 14"
                                    type="number"
                                    validate={{
                                      pattern: {
                                        value: "^[0-9]+$",
                                        errorMessage: "Only Digits",
                                      },
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <div className="mb-3">
                                  <AvField
                                    name="kids_male"
                                    label="Number of Kids (Male)"
                                    placeholder="Age Between 3 to 9"
                                    type="number"
                                    validate={{
                                      pattern: {
                                        value: "^[0-9]+$",
                                        errorMessage: "Only Digits",
                                      },
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="mb-3">
                                  <AvField
                                    name="kids_female"
                                    label="Number of Kids (Female)"
                                    placeholder="Age Between 3 to 9"
                                    type="number"
                                    validate={{
                                      pattern: {
                                        value: "^[0-9]+$",
                                        errorMessage: "Only Digits",
                                      },
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </TabPane>
                        </TabContent>
                        {this.state.loading ? (
                          <div className="text-center m-4">
                            <Spinner className="me-2 mt-2" color="primary" />
                          </div>
                        ) : (
                          <ul className="pager wizard twitter-bs-wizard-pager-link">
                            {this.state.activeTabProgress === 1 ? null : (
                              <li
                                className={
                                  this.state.activeTabProgress === 1 ? "previous disabled" : "previous"
                                }
                              >
                                <Link
                                  to="#"
                                  onClick={() => {
                                    this.toggleTabProgress(this.state.activeTabProgress - 1);
                                  }}
                                >
                                  Previous
                                </Link>
                              </li>
                            )}
                            {this.state.activeTabProgress === 3 ? (
                              this.state.loading ? (
                                ""
                              ) : (
                                <Button type="submit" color="primary" className="me-1 next float-end">
                                  Submit
                                </Button>
                              )
                            ) : (
                              <li
                                className={
                                  this.state.activeTabProgress === 3 ? "next disabled" : "next"
                                }
                              >
                                <Link
                                  to="#"
                                  onClick={() => {
                                    this.state.activeTabProgress === 3
                                      ? console.log()
                                      : this.toggleTabProgress(this.state.activeTabProgress + 1);
                                  }}
                                >
                                  Next
                                </Link>
                              </li>
                            )}
                          </ul>
                        )}
                      </AvForm>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default NewItinerary;